import {
  EInvitationStatus,
  IInvitation,
  JupiterTheme,
  CloseButton,
} from '@jupiterone/jupiter-web-toolkit';
import {
  Avatar,
  CircularProgress,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { Users } from 'react-feather';
import useSharedUsersAndAccountStyles from 'navbar/src/jupiterAccountSettings/AccountSettings/useSharedUsersAndAccountStyles';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    groupAvatarPending: {
      background: theme.palette.coolGrey[600],
    },
    listActionIconPositive: {
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.green[800],
      },
    },
    listActionIconNegative: {
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.red[500],
      },
    },
  })
);

interface IProps {
  onInviteAction: (invitation: IInvitation, action: EInvitationStatus) => void;
  invitation: IInvitation;
  primaryAction?: (invitation: IInvitation) => void;
  primaryActionIcon?: any;
  primaryText?: string;
}

const InvitationList = ({
  invitation,
  onInviteAction,
  primaryAction,
  primaryActionIcon,
  primaryText,
}: IProps) => {
  const classes = useStyles();
  const sharedClasses = useSharedUsersAndAccountStyles();

  const [loading, setLoading] = useState<boolean>(false);

  const doPrimaryAction = () => {
    if (primaryAction) {
      setLoading(true);
      primaryAction(invitation);
    }
  };

  const declineInvite = () => {
    setLoading(true);
    onInviteAction(invitation, EInvitationStatus.rejected);
  };

  return (
    <ListItem className={sharedClasses.listItem}>
      <ListItemAvatar>
        <Avatar
          className={clsx(
            sharedClasses.groupAvatar,
            classes.groupAvatarPending
          )}
        >
          <Users />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        disableTypography={false}
        classes={{
          primary: sharedClasses.primaryInvitation,
          secondary: sharedClasses.secondaryInvitation,
        }}
        primary={
          primaryText || `[${invitation.accountName}] ${invitation.groupName}`
        }
      />
      {loading ? (
        <ListItemSecondaryAction>
          <CircularProgress />
        </ListItemSecondaryAction>
      ) : (
        <ListItemSecondaryAction>
          {primaryAction && primaryActionIcon && (
            <Tooltip enterDelay={500} placement="top" title="Join">
              <IconButton
                className={clsx(
                  sharedClasses.listActionIcon,
                  classes.listActionIconPositive
                )}
                aria-label="Join"
                onClick={doPrimaryAction}
              >
                {primaryActionIcon}
              </IconButton>
            </Tooltip>
          )}
          <CloseButton
            onClose={declineInvite}
            className={clsx(
              sharedClasses.listActionIcon,
              classes.listActionIconNegative
            )}
            aria-label="Decline"
            size={24}
            label="Decline"
          />
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};

export default InvitationList;
